module.exports = __webpack_public_path__ + "static/img/spring_my_message_icon.f34b368.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/newVersion/spring_my_message_icon.png
// module id = 354
// module chunks = 32